<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/chamadoManutencao', query: $route.query }">
        Manutenção/Chamado Manutencao
      </router-link>
      <label class="labelBar"> / </label>
      <label> Editar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              v-model="equipamentoSelected"
              :items="equipamentos"
              label="Equipamento *"
              item-text="centroCusto"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Equipamento é obrigatório']"
              required
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-subheader><strong>Prioridade</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="tipo" row>
                <v-radio label="Normal" value="N"></v-radio>
                <v-radio label="Emergencial" value="E"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Relato"
              v-model="descricao"
              v-uppercase
              clear-icon="mdi-close-circle"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right" cols="12" sm="10">
          <v-btn
            @click="showModalOS = !showModalOS"
            color="primary"
            :disabled="chamadoManutencao.status != 'EA'"
            class="mr-4"
          >
            Gerar OS
          </v-btn>
          <v-btn
            @click="showModalFinalizar = !showModalFinalizar"
            color="primary"
            :disabled="chamadoManutencao.status != 'EA'"
            class="mr-4"
          >
            Finalizar
          </v-btn>
          <v-btn :to="{ path: '/chamadoManutencao', query: $route.query }" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn
            @click="enviar"
            color="success"
            :disabled="chamadoManutencao.status != 'EA'"
            class="mr-4"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModalFinalizar"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Baixar Chamado de Manutenção</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div>
              <label
                ><h3>
                  Deseja realmente inativar a requisição
                  {{ this.chamadoManutencao.id }}?
                </h3></label
              >
            </div>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Justificativa"
                    v-model="justificativa"
                    clear-icon="mdi-close-circle"
                    :rules="[(v) => !!v || 'A justificativa é obrigatória']"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn
                  @click="showModalFinalizar = false"
                  color="error"
                  class="mr-4"
                >
                  Cancelar
                </v-btn>
                <v-btn @click="finalizar" color="success" class="mr-4">
                  Confirmar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      style="z-index: 9999"
      v-model="showModalOS"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline"
            >Chamado Nº {{ this.chamadoManutencao.id }}/Equipamento:
            {{ this.equipamentoSelected.centroCusto }}/Prioridade:
            {{ this.tipo == "N" ? "Normal" : "Emergencial" }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form3" v-model="validFrm3" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    label=""
                    v-model="descricao"
                    clear-icon="mdi-close-circle"
                    readonly
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="showModalOS = false" color="info" class="mr-4">
                  Cancelar
                </v-btn>
                <v-btn @click="gerarOS" color="success" class="mr-4">
                  Confirmar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  editarChamadoManutencaoAsync,
  gerarOSChamadoManutencaoAsync,
  finalizarChamadoManutencaoAsync,
} from "../../../services/chamadoManutencaoService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "criarChamadoManutencao",
  data: () => ({
    tipo: "N",
    overlay: false,
    showModalOS: false,
    showModalFinalizar: false,
    valid: true,
    validFrm2: true,
    validFrm3: true,
    descricao: null,
    justificativa: null,
    equipamentoSelected: null,
    unidadeAdmSelected: null,
  }),
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("local", ["locais"]),
    ...mapState("chamadoManutencao", ["chamadoManutencao"]),
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
  },
  methods: {
    ...mapActions("ordemServico", [
      "atualizarOrdensServico",
      "atualizarOrdemServico",
    ]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarChamadoManutencaoAsync(
          this.chamadoManutencao.id,
          this.descricao,
          this.unidadeAdmSelected.id,
          this.equipamentoSelected.id,
          this.chamadoManutencao.status,
          this.tipo,
          this.chamadoManutencao.ativo
        );
        if (resposta?.status && resposta.status != 200)  {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push({ path: '/chamadoManutencao', query: this.$route.query });
        }
      }
    },
    findLocal(idLocal) {
      return this.locais.find((l) => l.id === idLocal);
    },
    findEquipamento(idEquipamento) {
      return this.equipamentos.find((e) => e.id === idEquipamento);
    },
    checkAssociacao() {},
    async gerarOS() {
      this.showModalOS = false;
      this.overlay = true;
      const resposta = await gerarOSChamadoManutencaoAsync(
        this.chamadoManutencao.id,
        this.descricao,
        this.unidadeAdmSelected.id,
        this.equipamentoSelected.id,
        this.tipo,
        this.chamadoManutencao.ativo
      );
        if (resposta?.status && resposta.status != 200) {
        this.overlay = false;
        this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
      } else {
        this.atualizarOrdemServico(this.mountObjOs(resposta.data));
        this.atualizarOrdensServico();
        this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "OS gerada com sucesso!",
            color: "success",
            timeout: 3000,
          });
        this.$router.push(`/ordemServico/editar`);
      }
    },
    async finalizar() {
      if (this.$refs.form2.validate()) {
        this.overlay = true;
        const resposta = await finalizarChamadoManutencaoAsync(
          this.chamadoManutencao.id,
          this.descricao,
          this.justificativa,
          this.unidadeAdmSelected.id,
          this.equipamentoSelected.id,
          this.tipo,
          this.chamadoManutencao.ativo
        );

        if (resposta?.status && resposta.status != 200) {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Chamado finalizado!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push({ path: '/chamadoManutencao', query: this.$route.query });
        }
      }
    },
    mountObjOs(newos) {
      var ordemServico = new Object();
      ordemServico.id = newos.id;
      ordemServico.idChamado = this.chamadoManutencao.id;
      ordemServico.status = newos.status;
      ordemServico.prioridade = this.tipo;
      ordemServico.idUnidadeAdm = this.unidadeAdmSelected.id;
      ordemServico.idEquipamento = this.equipamentoSelected.id;
      ordemServico.ativo = true;
      return ordemServico;
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(1);
    this.unidadeAdmSelected =
      this.findLocal(this.chamadoManutencao.idUnidadeAdm) || null;
    this.equipamentoSelected =
      this.findEquipamento(this.chamadoManutencao.idEquipamento) || null;
    this.descricao = this.chamadoManutencao.descricao;
    this.itemTroca = this.chamadoManutencao.itemTroca;
    this.ativo = this.chamadoManutencao.ativo;
    this.tipo = this.chamadoManutencao.prioridade == "Normal" ? "N" : "E";
  },
};
</script>
